module.exports = __webpack_public_path__ + "static/media/google-small-icon.2ac5d02a.webp";